module.exports = __webpack_public_path__ + "img/xp.e3645610.png";